import React, { useState, useEffect } from 'react';
import SingleMusic from './SingleMusicAll';
import Footer from './Footer';
import Modal from './Modal';
import Reveal from './Reveal';

const Card = ({ id, title, thumbnail, onClick }) => (
  <div
    className="bg-white dark:bg-[#111010] border border-gray-200 dark:border-white/10 h-full text-gray-900 dark:text-white
      shadow-sm hover:shadow-lg dark:shadow-black/30 dark:hover:shadow-black/50 overflow-hidden rounded-lg cursor-pointer
      transition-all duration-300 hover:-translate-y-1"
    onClick={() => onClick(id)}
  >
    <img src={thumbnail} alt={title} className="xl:h-[80%] w-full aspect-square object-cover" loading="lazy" />
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-1 truncate">{title}</h2>
    </div>
  </div>
);

const MusicGridSkeleton = () => (
  <div className="w-[80%] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" aria-hidden="true">
    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="bg-gray-100 dark:bg-white/5 rounded-lg aspect-square animate-pulse" />
    ))}
  </div>
);

const MusicCarousel = () => {
  const [musicData, setMusicData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMusic, setSelectedMusic] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/api/music/all`)
      .then((response) => response.json())
      .then((data) => setMusicData(data))
      .catch((error) => console.error('Error fetching music:', error))
      .finally(() => setLoading(false));
  }, []);

  const handleCardClick = (id) => {
    const music = musicData.find((m) => m.ID === id);
    if (music) {
      setSelectedMusic({
        title: music.name,
        thumbnail: `${process.env.REACT_APP_BASE_URL}${music.image_video}`,
        ...music,
      });
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setSelectedMusic(null);
    setIsModalOpen(false);
  };

  const filteredMusicData = musicData.filter((music) =>
    music.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="flex flex-col pt-[150px] justify-center items-center min-h-screen bg-white dark:bg-black transition-colors duration-300">
      <div className="w-full flex justify-between items-center px-4 mb-1">
        <div className="md:w-1/2 w-1/3 text-right">
          <h1 className="text-[12px] md:text-[30px] text-gray-500 dark:text-gray-400">AVAILABLE NOW</h1>
        </div>
        <div className="w-1/2 text-left">
          <h1 className="font-ettlora md:text-6xl text-6xl pb-[30px] md:text-8xl lg:text-[120px] text-gray-900 dark:text-white">Music</h1>
        </div>
      </div>

      <div className="w-full flex justify-center mb-8">
        <input
          type="text"
          placeholder="Search…"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-4/5 sm:w-2/3 p-2 border-b-2 border-gray-300 dark:border-white/20 bg-transparent
            text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:border-gray-900 dark:focus:border-white"
        />
      </div>

      {loading ? (
        <div className="mb-16"><MusicGridSkeleton /></div>
      ) : filteredMusicData.length === 0 ? (
        <p className="text-gray-500 dark:text-gray-400 mb-16">No music found.</p>
      ) : (
        <div className="w-[80%] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-16">
          {filteredMusicData.map((music, i) => (
            <Reveal key={music.ID} delay={Math.min(i, 8) * 50}>
              <Card
                id={music.ID}
                title={music.name}
                thumbnail={`${process.env.REACT_APP_BASE_URL}${music.image_video}`}
                onClick={handleCardClick}
              />
            </Reveal>
          ))}
        </div>
      )}

      <Footer />

      <Modal show={!!selectedMusic && isModalOpen} onClose={closeModal}>
        {selectedMusic && <SingleMusic music={selectedMusic} />}
      </Modal>
    </div>
  );
};

export default MusicCarousel;
